// extracted by mini-css-extract-plugin
export var actionButton = "_de-0";
export var attachmentLine = "_de-1";
export var fileInput = "_de-2";
export var fileUploadWrapper = "_de-4";
export var footer = "_de-3";
export var modalContent = "_de-5";
export var paperclip = "_de-6";
export var quillEditor = "_de-7";